import React, { useState, useEffect, useContext } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import CustomInput from "app/components/CustomInput/CustomInput.js";
import Button from "app/components/CustomButtons/Button.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import { Redirect } from 'react-router';
import axios from 'axios';
import $ from 'jquery';
import { LoginStatusContext } from "app/context/LoginStatusContext";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
    colour: {
        backgroundColor: "#5DC0E7",
    }
};

const useStyles = makeStyles(styles);

export default function UserProfile() {
    const classes = useStyles();

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const { setIsLoggedIn } = useContext(LoginStatusContext);
    
    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`)
                        .then(() => setIsLoggedIn(true));
                
            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    const renderFormUserProfile = (items) => {

        if (items === null) {
            return;
        }
        return (
            <CardBody>
                {items.map(item =>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={7}>
                            <CustomInput
                                labelText="Forename"
                                id="forename"
                                name="forename"
                                defaultValue={item.forename}
                                formControlProps={{
                                    fullWidth: true,
                                }}
                            />
                        </GridItem>
                    </GridContainer>
                )}
                {items.map(item =>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={7}>
                            <CustomInput
                                labelText="Surname"
                                id="surname"
                                name="surname"
                                defaultValue={item.surname}
                                formControlProps={{
                                    fullWidth: true,
                                }}
                            />
                        </GridItem>
                    </GridContainer>
                )}
                {items.map(item =>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={7}>
                            <CustomInput
                                labelText="Email"
                                id="email"
                                name="email"
                                defaultValue={item.email}
                                formControlProps={{
                                    fullWidth: true,
                                }}
                            />
                        </GridItem>
                    </GridContainer>
                )}
                {items.map(item =>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={7}>
                            <CustomInput
                                labelText="Password"
                                id="password"
                                name="password"
                                type="password"
                                defaultValue={item.password}
                                formControlProps={{
                                    fullWidth: true,
                                }}
                            />
                        </GridItem>
                    </GridContainer>
                )}
            </CardBody>
        );
    }

    const onUserProfileSubmit = (e) => {
        e.preventDefault();

        const form = e.currentTarget;

        const formData = new FormData(form);

        const plainFormData = Object.fromEntries(formData.entries());
        const formDataJsonString = JSON.stringify(plainFormData);
        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/userProfile`,
                formDataJsonString
            )
            .then(function (response) {
                if (response.data === "Updated") {
                    $("#APIResponse").show();
                }
            })
            .catch(function (error) {
            });
    };

    useEffect(() => {
        async function getUserProfile() {
            return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/userProfile`)
                .then((response) => {
                    setItems(response.data);
                    setLoading(false);
                });
        }
        getUserProfile();
    }, []);

    let contents = loading
        ? <em>Loading...</em>
        : renderFormUserProfile(items);

        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={7}>
                        {sessionStorage.getItem('APIResponse')}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader className={classes.colour}>
                                <h4 className={classes.cardTitleWhite}>User Profile</h4>
                                <p className={classes.cardCategoryWhite}>Update your profile</p>
                            </CardHeader>
                            <form onSubmit={onUserProfileSubmit}>
                                {contents}
                                <div id="APIResponse" style={{ display: "none" }}>
                                    <p className={classes.color} style={{ marginLeft: "20px" }}>Profile successfully updated!</p>
                                </div>
                                <CardFooter>
                                    <Button className={classes.colour} type="submit">Update Profile</Button>
                                </CardFooter>
                            </form>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
}
